import { convertDate } from '../helper-functions/convertdate';
import moment from 'moment';

export class DateConverterValueConverter {

  toView(value: moment.MomentInput) {
    return convertDate(value);
  }

  fromView(value: unknown) {
    return value;
  }
}

